import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api/client.js';

export interface RecentGameInfo {
  gameId: string;
  gameCode: string;
  gameName: string;
  imageUrl: string | null;
  providerId: string;
  providerCode: string;
  providerDisplayName: string;
  lastPlayedAt: string;
}

interface RecentlyPlayedResponse {
  items: RecentGameInfo[];
}

export function useRecentGames(limit = 6) {
  return useQuery({
    queryKey: ['games', 'recent', limit],
    queryFn: async (): Promise<RecentGameInfo[]> => {
      const res = await apiFetch<RecentlyPlayedResponse>(
        `/recently-played?limit=${limit}`,
      );
      return res.items.map((r) => ({
        ...r,
        providerCode: r.providerDisplayName || r.providerCode,
      }));
    },
    staleTime: 60_000,
  });
}
